import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import App from './App';
import OrgManagement from './pages/OrgManagement';
import ProjectManagement from './pages/ProjectManagement';
import AppRegistry from './pages/AppRegistry';
import SCMConnections from './pages/SCMConnections';
import OAuthCallback from './pages/OAuthCallback';
import AgentCatalog from './pages/AgentCatalog';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { msalConfig, loginRequest } from './authConfig';
import { OrgProjectProvider } from './contexts/OrgProjectContext';
import { setMsalInstance } from './apiClient';

const root = ReactDOM.createRoot(document.getElementById('root'));
const clientId = msalConfig.auth.clientId;

if (clientId) {
  // Entra ID configured — use real Microsoft auth.
  // MSAL v3 requires async initialization before it can process redirect responses.
  const msalInstance = new PublicClientApplication(msalConfig);
  // Share the MSAL instance with the API client for token acquisition
  setMsalInstance(msalInstance);

  function SignInPage() {
    const { instance } = useMsal();
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
      }}>
        <div style={{
          background: '#fff', borderRadius: 16, padding: '48px 40px', textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)', maxWidth: 420, width: '100%',
        }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🤖</div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1F2E', margin: '0 0 8px' }}>
            AI-SDLC Platform
          </h1>
          <p style={{ fontSize: 13, color: '#57606A', margin: '0 0 32px', lineHeight: 1.5 }}>
            Agentic Application Modernization Pipeline
          </p>
          <button
            onClick={() => instance.loginRedirect(loginRequest)}
            style={{
              padding: '14px 32px', borderRadius: 10, fontSize: 14, fontWeight: 700,
              border: 'none', cursor: 'pointer', width: '100%',
              background: '#0969DA', color: '#fff',
              boxShadow: '0 4px 12px rgba(9,105,218,0.4)',
            }}
          >
            Sign in with Microsoft
          </button>
          <p style={{ fontSize: 11, color: '#8B949E', marginTop: 20 }}>
            Secured by Microsoft Entra ID
          </p>
        </div>
      </div>
    );
  }

  function renderApp() {
    root.render(
      <MsalProvider instance={msalInstance}>
        <AuthenticatedTemplate>
          <OrgProjectProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/orgs" element={<OrgManagement />} />
                <Route path="/orgs/:orgId/projects" element={<ProjectManagement />} />
                <Route path="/orgs/:orgId/projects/:projectId/apps" element={<AppRegistry />} />
                <Route path="/orgs/:orgId/scm-connections" element={<SCMConnections />} />
                <Route path="/oauth/callback/:provider" element={<OAuthCallback />} />
                <Route path="/agents" element={<AgentCatalog />} />
                <Route path="*" element={<App />} />
              </Routes>
            </BrowserRouter>
          </OrgProjectProvider>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <SignInPage />
        </UnauthenticatedTemplate>
      </MsalProvider>
    );
  }

  // Initialize MSAL and handle any pending redirect before rendering.
  // Without this, the auth code in the URL fragment is never processed
  // and the user appears unauthenticated after redirect back from Entra ID.
  msalInstance.initialize().then(() => {
    msalInstance.handleRedirectPromise().then(() => {
      renderApp();
    }).catch((err) => {
      console.error('MSAL redirect error:', err);
      renderApp();
    });
  });
} else {
  // No Entra ID configured — show sign-in page that bypasses to App
  function SignInPageLocal() {
    const [entered, setEntered] = React.useState(false);
    if (entered) return (
      <OrgProjectProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/orgs" element={<OrgManagement />} />
            <Route path="/orgs/:orgId/projects" element={<ProjectManagement />} />
            <Route path="/orgs/:orgId/projects/:projectId/apps" element={<AppRegistry />} />
            <Route path="/orgs/:orgId/scm-connections" element={<SCMConnections />} />
            <Route path="/oauth/callback/:provider" element={<OAuthCallback />} />
            <Route path="/agents" element={<AgentCatalog />} />
            <Route path="*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </OrgProjectProvider>
    );
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
      }}>
        <div style={{
          background: '#fff', borderRadius: 16, padding: '48px 40px', textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)', maxWidth: 420, width: '100%',
        }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🤖</div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1F2E', margin: '0 0 8px' }}>
            AI-SDLC Platform
          </h1>
          <p style={{ fontSize: 13, color: '#57606A', margin: '0 0 32px', lineHeight: 1.5 }}>
            Agentic Application Modernization Pipeline
          </p>
          <button
            onClick={() => setEntered(true)}
            style={{
              padding: '14px 32px', borderRadius: 10, fontSize: 14, fontWeight: 700,
              border: 'none', cursor: 'pointer', width: '100%',
              background: '#0969DA', color: '#fff',
              boxShadow: '0 4px 12px rgba(9,105,218,0.4)',
            }}
          >
            Sign in with Microsoft
          </button>
          <p style={{ fontSize: 11, color: '#8B949E', marginTop: 20 }}>
            Secured by Microsoft Entra ID
          </p>
        </div>
      </div>
    );
  }

  root.render(<SignInPageLocal />);
}
